import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import moment from 'moment'
import uuid from 'node-uuid'
import cx from 'classnames'
import {Row, Col, PageHeader, Panel, PanelGroup, Nav, NavItem, Tooltip, OverlayTrigger, ButtonGroup, ButtonToolbar, Button} from 'react-bootstrap'
import {connectWizard, major} from '../../core/wizard'
import {humanize} from '../../core/momentz'
import {linkFinder} from '../../core/links'
import extract, {sanitize, replace} from '../../core/extract'
import {matchMedia} from '../../core/browser'
import {isSameDay} from '../../core/datez'
import phonez from '../../core/phonez'
import Header from '../../core/components/Header'
import Card from '../../core/components/Card'
import CardGroup from '../../core/components/CardGroup'
import Box from '../../core/components/Box'
import ButtonToggle from '../../core/components/ButtonToggle'
import Icon from '../../core/components/Icon'
import DownloadIcon from '../../core/components/DownloadIcon'
import Markdown from '../../core/components/Markdown'
import NextStepCard from '../../workflow/components/NextStepCard'
import NewTicketClaimCard from '../../claim/components/NewTicketClaimCard'
import SatisfactionButton from '../../satisfaction/components/SatisfactionButton'
import AnswerModal from '../../satisfaction/components/AnswerModal'
import {CLOSE_TICKET_CMD_TYPES, CORRECT_TICKET_EVENT_NAMES, INCIDENT_TYPE_ITEM_ICONS, Ticket} from '../models'
import {
    PDF_TICKETS_EXPORTED,
    exportPdfTicket,
    LINKS_LOADED,
    restrictAccessToCall,
    loadTicket,
    enterTicket, CORRECT_OTP,
} from '../actions'
import i18n from '../i18n'
import TicketCallerCard from './TicketCallerCard'
import TicketAddressCard from './TicketAddressCard'
import TicketAssigneeCard from './TicketAssigneeCard'
import OpenTicketLayout from './OpenTicketLayout'
import OpenTicketStreamCardLayout from './OpenTicketStreamCardLayout'
import OpenTicketCompanyCard from './OpenTicketCompanyCard'
import IdentifyAssigneeCard from './IdentifyAssigneeCard'
import AcceptRefuseInterventionCard from './AcceptRefuseInterventionCard'
import AddMessageCard from './AddMessageCard'
import CloseTicketCard from './CloseTicketCard'
import OpenTicketCompanyModal from './OpenTicketCompanyModal'
import ReportSendingServiceOrderModal from './ReportSendingServiceOrderModal'
import DefineInterventionDeadlineModal from './DefineInterventionDeadlineModal'
import ReportFormalNoticeForProviderModal from './ReportFormalNoticeForProviderModal'
import ScheduleInterventionModal from './ScheduleInterventionModal'
import CorrectTicketInformationsModal from './CorrectTicketInformationsModal'
import CorrectTicketEventInformationsModal from './CorrectTicketEventInformationsModal'
import ReceiveCallModal from './ReceiveCallModal'
import EmitCallToModal from './EmitCallToModal'
import ExportTicketsModal from './ExportTicketsModal'
import FinishMissionModal from './FinishMissionModal'
import style from './TicketDetail.less'
import TicketCompanyInfosCard from './TicketCompanyInfosCard'
import TicketCorrectOTPPicker from './TicketCorrectOTPPicker'
import {apiOption, apiResponse, apiUrl} from '../../core/fetchz'
import config from '../../config'
import {errorStatus} from '../../core/redux/status'
import ShowDocumentsCard from './ShowDocumentsCard'
import ToggleablePanel from '../../core/components/ToggleablePanel'

function selectActiveStep(steps, {ticket}) {
    if (!ticket.uid) return 1.1
    if (!ticket.state) return 2.1

    switch (ticket.state.value) {
        case 'AssigneeIdentified':
            return 3.2
        case 'InterventionAccepted':
            return 4.3
        case 'InterventionStarted':
            return 5.3
        default:
            return 6
    }
}

function findState(step) {
    switch (major(step)) {
        case 2:
            return 'TicketOpened'
        case 3:
            return 'AssigneeIdentified'
        case 4:
            return 'InterventionAccepted'
        case 5:
            return 'InterventionStarted'
        case 6:
            return 'TicketClosed'
    }
}

function eventAggregator(result, event) {
    var aggrega = result.find((e) => isSameDay(e.date, event.date))

    if (!aggrega) {
        aggrega = {
            date: event.date,
            events: [],
            commentCount: 0
        }
        result.push(aggrega)
    }

    aggrega.events.push(event)

    if (event.eventName == 'MessageAdded' || event.data.comment) {
        aggrega.commentCount++
    }
    return result
}

function modalName(result) {
    switch (result) {
        case 'EmitCallTo':
            return 'EmitCallToModal'
        case 'ReceiveCall':
            return 'ReceiveCallModal'
        default:
            return result
    }
}

class TicketDetail extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            missionFinishedJournalEvents: [],
            journalAggregations: []
        }

        window.addEventListener('message', (event) => {
            if (event.data.type === 'RefreshTicket') {
                this.refreshTicket()
            }
        }, false)
    }

    refreshTicket = () => {
        const {dispatch, ticket} = this.props

        dispatch(loadTicket(ticket.uid))
    }

    _cleanJournal(ticket) {
        return ticket.journal.reduce((acc, e) => {
            if(e.eventName === 'InterventionStarted') {
                const evt = acc.filter(e => e.eventName === 'InterventionStarted')
                    .concat(e)
                    .sort((e1,e2) => new Date(e2.data.sentDate).getTime() - new Date(e1.data.sentDate).getTime())[0]

                return acc.filter(e => e.eventName !== 'InterventionStarted').concat(evt)
            } else if(e.eventName === 'InterventionFinished') {
                const evt = acc.filter(e => e.eventName === 'InterventionFinished')
                    .concat(e)
                    .sort((e1,e2) => new Date(e2.data.sentDate).getTime() - new Date(e1.data.sentDate).getTime())[0]

                return acc.filter(e => e.eventName !== 'InterventionFinished').concat(evt)
            } else {
                return acc.concat(e)
            }
        }, [])
    }

    componentWillMount() {
        const {ticket} = this.props

        const activeJournalEvent = Ticket.findActiveStateJournalEvent(ticket)
        const missionFinishedJournalEvents = Ticket.findJournalEvents(ticket, 'MissionFinished')

        const journalAggregations = this._cleanJournal(ticket).reduce(eventAggregator, [])
        this.setState({activeJournalEvent, missionFinishedJournalEvents, journalAggregations})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticket != this.props.ticket) {
            const {ticket} = nextProps

            const activeJournalEvent = Ticket.findActiveStateJournalEvent(ticket)
            const missionFinishedJournalEvents = Ticket.findJournalEvents(ticket, 'MissionFinished')
            const journalAggregations = this._cleanJournal(ticket).reduce(eventAggregator, [])
            this.setState({activeJournalEvent, missionFinishedJournalEvents, journalAggregations, activeAssignee: ticket.assignee})
        }
    }

    _closeModalOTP = () => {
        this.setState({modalOtpShow : false})
    }
    _openModalOTP = (e) => {
        e.preventDefault()

        const {dispatch, ticket} = this.props
        const {openingTicketPurpose, qualification} = ticket || {}
        const {callPurposeUid: uid, callPurpose: label} = openingTicketPurpose
        const value = {uid, label}

        this.setState({modalOtpShow : true})
        dispatch({type: CORRECT_OTP, cmd : {value, qualification}})
    }

    _navigate(path) {
        const {dispatch} = this.props
        dispatch(push(path))
    }

    _openModal(event, name) {
        event.preventDefault()
        this.setState({openedModal: name})
    }

    _openEventModal(event, name, activeEvent) {
        event.preventDefault()
        this.setState({openedModal: name, activeEvent})
    }

    _openEmitReceiveCallModal(event, result, activeAssignee, activeCaller, activeContactToCallback, activeTicket) {
        event.preventDefault()

        const openedModal = modalName(result)
        this.setState({openedModal, activeAssignee, activeCaller, activeContactToCallback, activeTicket})
    }

    _closeModal() {
        this.setState({openedModal: null})
    }

    render() {
        const {progress, ticket, wizard, _appLinks, dispatch} = this.props
        const {activeJournalEvent, missionFinishedJournalEvents, journalAggregations} = this.state
        const {openedModal, activeEvent, activeAssignee, activeCaller, activeContactToCallback, activeTicket} = this.state
        
        const headerHelp = () => (
            <div className={style.headerHelp}>
                <Icon icon='clock' size='xs' />
                <span> {moment(ticket.dates.created).format(i18n.creationDateTimeFormat)} </span>
                <Icon icon={Ticket.accurateStatus(ticket)} size='sm' />
            </div>
        )

        const cardHeader = (title) => (
            <h5>{title}</h5>
        )

        const cardHeaderLarge = (title) => (
            <h3>{title}</h3>
        )

        const boxBackground = (icon) => (
            <Icon icon={icon} size='xl' />
        )

        const journalPanelHeader = (aggrega) => (
            <h5 className={style.journalHeader}>
                {aggrega.commentCount > 0 && (
                    <div className={style.count}>
                        <Icon icon='comment' size='sm' count={aggrega.commentCount} />
                    </div>
                )}
                <div className={style.container}>
                    <span>> {moment(aggrega.date).format(i18n.dateFormat.longer)} </span>
                    <Icon icon='up' size='sm' />
                </div>
            </h5>
        )

        const tooltip = (text, status) => {
            return (
                <Tooltip className={status && 'tooltip-' + status}>
                    {text}
                </Tooltip>
            )
        }

        const metricBoxes = (
            <Row>
                <Col xs={6}>
                    <Box
                        kind='rounded'
                        background={boxBackground('hourglass')}>
                        <div className={style.metricBox}>
                            <p>{i18n.callCenterResponseTime}</p>
                            <OverlayTrigger
                                placement='bottom'
                                overlay={tooltip(i18n.callCenterResponseTimeText)}>
                                <div className={style.time}>
                                    {humanize(moment.duration(ticket.stats.transmissionTime))}
                                </div>
                            </OverlayTrigger>
                        </div>
                    </Box>
                </Col>
                <Col xs={6}>
                    <Box
                        kind='rounded'
                        background={boxBackground('clock-elapsed')}>
                        <div className={style.metricBox}>
                            <p>{i18n.callCenterReactionTime}</p>
                            <OverlayTrigger
                                placement='bottom'
                                overlay={tooltip(i18n.callCenterReactionTimeText)}>
                                <div className={style.time}>
                                    {humanize(moment.duration(ticket.stats.callCenterReactionTime))}
                                </div>
                            </OverlayTrigger>
                        </div>
                    </Box>
                </Col>
            </Row>
        )

        const finishMissionEventCard = missionFinishedJournalEvents.length > 0 && (
            <Box active
                status='danger'>
                <div className={style.missionFinished}>
                    {missionFinishedJournalEvents.map((event, index) => (
                        <p
                            key={index}>
                            <strong>{event.data.companyName}</strong>
                            <span> {i18n.finishedMissionEvent}</span>
                        </p>
                    ))}
                </div>
            </Box>
        )

        const patrimonyUid = (ticket.linkedEntities && ticket.linkedEntities.patrimony && ticket.linkedEntities.patrimony.uid) || null
        const companyCard = ticket.linkedEntities && ticket.linkedEntities.clientCompany && (
            <TicketCompanyInfosCard
                company={{uid: ticket.linkedEntities.clientCompany.uid, name: ticket.linkedEntities.clientCompany.name}}
                agencies={ticket.linkedEntities.agencies}
                patrimonyUid={patrimonyUid} />
        )

        const additionalDataCard = (
            <Card
                header={cardHeaderLarge(i18n.additionalData)}>
                <ul className={style.data}>
                    {Object.keys(ticket.additionalDataz).map((key, index) => (
                        <li 
                            key={index}>
                            <label>> {key} :</label>
                            <span> {ticket.additionalDataz[key]}</span>
                        </li>
                    ))}
                </ul>
            </Card>
        )

        const instructionsCard = ticket.instructions && (
            <Card
                status='danger'
                header={cardHeaderLarge(i18n.instructions)}>
                <div className={style.instruction}>
                    <Markdown markdown={ticket.instructions} />
                </div>
            </Card>
        )

        const editMenuCard = (
            <Card
                header={cardHeaderLarge(i18n.updateTicket)}>
                <ul className={style.menu}>
                    <li>
                        <Button
                            bsStyle='link'
                            disabled={!ticket._links.find(linkFinder('CorrectTicketInformations'))}
                            onClick={(e) => this._openModal(e, 'CorrectTicketInformationsModal')}>
                            <Icon icon='plus' size='xs' />
                            <span> {i18n.correctTicketInformations}</span>
                        </Button>
                    </li>
                    <li>
                        <Button
                            bsStyle='link'
                            disabled={!ticket._links.find(linkFinder('ReceiveCall'))}
                            onClick={(e) => this._openEmitReceiveCallModal(e, 'ReceiveCallModal', ticket.assignee, ticket.caller, ticket.contactToCallback)}>
                            <Icon icon='plus' size='xs' />
                            <span> {i18n.receiveCallzAction}</span>
                        </Button>
                    </li>
                    <li>
                        <Button
                            bsStyle='link'
                            disabled={!ticket._links.find(linkFinder('EmitCallTo'))}
                            onClick={(e) => this._openEmitReceiveCallModal(e, 'EmitCallToModal', ticket.assignee, ticket.caller, ticket.contactToCallback)}>
                            <Icon icon='plus' size='xs' />
                            <span> {i18n.emitCallzAction}</span>
                        </Button>
                    </li>
                    <li>
                        <Button
                            bsStyle='link'
                            disabled={!ticket._links.find(linkFinder('ScheduleIntervention'))}
                            onClick={(e) => this._openModal(e, 'ScheduleInterventionModal')}>
                            <Icon icon='plus' size='xs' />
                            <span> {i18n.scheduleIntervention}</span>
                        </Button>
                    </li>
                    <li>
                        <Button
                            bsStyle='link'
                            disabled={!ticket._links.find(linkFinder('FinishMission'))}
                            onClick={(e) => this._openModal(e, 'FinishMissionModal')}>
                            <Icon icon='plus' size='xs' />
                            <span> {i18n.finishMission}</span>
                        </Button>
                    </li>
                    <li>
                        <Button
                            bsStyle='link'
                            disabled={!ticket._links.find(linkFinder('ReportSendingServiceOrder'))}
                            onClick={(e) => this._openModal(e, 'ReportSendingServiceOrderModal')}>
                            <Icon icon='plus' size='xs' />
                            <span> {i18n.reportSendingServiceOrder}</span>
                        </Button>
                    </li>
                    <li>
                        <Button
                            bsStyle='link'
                            disabled={!ticket._links.find(linkFinder('DefineInterventionDeadline'))}
                            onClick={(e) => this._openModal(e, 'DefineInterventionDeadlineModal')}>
                            <Icon icon='plus' size='xs' />
                            <span> {i18n.defineInterventionDeadline}</span>
                        </Button>
                    </li>
                    <li>
                        <Button
                            bsStyle='link'
                            disabled={!ticket._links.find(linkFinder('ReportFormalNoticeForProvider'))}
                            onClick={(e) => this._openModal(e, 'ReportFormalNoticeForProviderModal')}>
                            <Icon icon='plus' size='xs' />
                            <span> {i18n.reportFormalNoticeForProvider}</span>
                        </Button>
                    </li>
                    <li>
                        <Button
                            bsStyle='link'
                            onClick={restrictAccessToCall(dispatch)}>
                            <Icon icon='plus' size='xs' />
                            <span> {i18n.restrictedAccess}</span>
                        </Button>
                    </li>
                </ul>
            </Card>
        )

        const exportButton = (
            <div className={style.export}>
                <OverlayTrigger
                    placement='bottom'
                    overlay={tooltip(progress[PDF_TICKETS_EXPORTED] && i18n.exportingTickets || i18n.exportPdfTickets, 'primary')}>
                    <Button
                        bsStyle='link'
                        bsSize='small'
                        disabled={!!progress[PDF_TICKETS_EXPORTED]}
                        onClick={(e) => this._openModal(e, 'ExportTicketsModal')}>
                        <DownloadIcon progress={progress[PDF_TICKETS_EXPORTED]} />
                    </Button>
                </OverlayTrigger>
            </div>
        )

        const stepTooltip = (step, active, success) => {
            const className = cx({
                'tooltip-disabled': !active && !success,
                'tooltip-danger': active,
                'tooltip-success': success
            })

            return (
                <Tooltip
                    className={className}>
                    {extract(i18n.stateEnum, findState(step))}
                </Tooltip>
            )
        }

        return (
            <div className={style.default}>
                <Row>
                    <Col sm={8}>
                        {wizard.matchActiveStep(1) && (
                            <Header>
                                <h3>{i18n.newTicket}</h3>
                            </Header>
                        )}
                        {wizard.matchActiveStep([2, 3, 4, 5, 6]) && (
                            <div>
                                <Header
                                    status='success'
                                    help={headerHelp()}>
                                    <h3>ticket n° {ticket.ref}</h3>
                                </Header>
                                <h4 className={style.state}>
                                    <span>{extract(i18n.stateEnum, ticket.state && ticket.state.value || 'TicketOpened')}</span>
                                    <small> {activeJournalEvent && Ticket.replaceJournalEvent(Ticket.extractJournalEvent(i18n.journalEventEnum, activeJournalEvent), activeJournalEvent)}</small>
                                </h4>
                            </div>
                        )}
                        <Nav justified
                            bsStyle='progress'
                            activeKey={wizard.majorActiveStep}>
                            {[2, 3, 4, 5, 6].map((step, index) => (
                                <NavItem
                                    key={index}
                                    eventKey={step}
                                    className={cx({'nav-success': step < wizard.activeStep})}>
                                    <OverlayTrigger
                                        placement='bottom'
                                        overlay={stepTooltip(step, wizard.matchActiveStep(step), step < wizard.activeStep)}>
                                            <span
                                                className={style.step}>
                                                {step - 1}
                                            </span>
                                    </OverlayTrigger>
                                </NavItem>
                            ))}
                        </Nav>
                        {wizard.matchActiveStep(1) && (
                            <div>
                                {!matchMedia('sm') && (
                                    <OpenTicketCompanyCard />
                                )}
                            </div>
                        )}
                        {wizard.matchActiveStep([2, 3, 4, 5, 6]) && (
                            <div>
                                {!matchMedia('sm') && (
                                    <div className={style.exportAndSatisfaction}>
                                        {exportButton}
                                        <div className={style.satisfaction}>
                                            <SatisfactionButton block
                                                ticket={ticket}
                                                onClick={(e) => this._openModal(e, 'AnswerModal')} />
                                        </div>
                                    </div>
                                )}
                                {!matchMedia('sm') && instructionsCard}
                                {!matchMedia('sm') && metricBoxes}
                                {!matchMedia('sm') && finishMissionEventCard}
                                {!matchMedia('sm') && companyCard}
                                {!matchMedia('sm') && <ShowDocumentsCard simplifiedRequest={ticket.linkedEntities.openedFromSimplifiedRequest}
                                                                         ticket={ticket.uid} />}

                                <ToggleablePanel startHidden={true}>
                                    <p className={style.callPurpose}>
                                        <label>{i18n.callPurpose}&nbsp;:</label>
                                        <span>&nbsp;{ticket.openingTicketPurpose.callPurpose}</span>
                                        {ticket._links.find(linkFinder('CorrectOpeningTicketPurpose')) &&

                                        <Button
                                            bsStyle={'link ' + style.myAction}
                                            onClick={this._openModalOTP}
                                            title={i18n.correctOtp}
                                            alt={i18n.correctOtp}
                                        >
                                            <Icon icon='pencil' size='xs' />
                                        </Button>}
                                    </p>

                                    {ticket.qualification && ticket.qualification.comment && (
                                        <div>
                                            <h5>{ticket.qualification.comment.title}</h5>
                                            <Markdown markdown={ticket.qualification.comment.comment} />
                                        </div>
                                    )}

                                    {ticket.qualification && !ticket.qualification.choices.isEmpty && (
                                        <p>
                                            <h5>Critères de qualification</h5>
                                            <div>
                                                {ticket.qualification.choices.map(c => {
                                                    return (<span key={c.criterionUid}>{`${c.criterionLabel}: ${c.choice.value}`}</span>)
                                                }).reduce((acc, item) => {
                                                    return acc.concat([item, <br/>])
                                                }, [])}
                                            </div>
                                        </p>
                                    )}
                                </ToggleablePanel>

                                <TicketCorrectOTPPicker
                                    company={ticket.linkedEntities.clientCompany}
                                    ticketUid={ticket.uid}
                                    onHide={this._closeModalOTP}
                                    show={this.state.modalOtpShow}
                                />
                                <div className={style.description}>
                                    <ToggleablePanel startHidden={false}>
                                        <label>{i18n.description}&nbsp;:</label>
                                        <Markdown markdown={ticket.request} />
                                    </ToggleablePanel>
                                </div>
                                <Row>
                                    <Col sm={6}>
                                        <TicketCallerCard
                                            kind='tab'
                                            onSubmit={(e, r, c) => this._openEmitReceiveCallModal(e, r, null, c, null)} />
                                    </Col>
                                    {ticket.contactToCallback && (
                                        <Col sm={6}>
                                            <Card
                                                kind='tab'
                                                header={cardHeader(i18n.contactToCallback)}>
                                                <h5>{ticket.contactToCallback.name}</h5>
                                                <ul className={style.contact}>
                                                    {ticket.contactToCallback.medium && ticket.contactToCallback.medium.contactMediumType == 'Phone' && (
                                                        <li>
                                                            <Icon icon='phone' size='xs' />
                                                            <span> {phonez(ticket.contactToCallback.medium && ticket.contactToCallback.medium.phone).format()}</span>
                                                        </li>
                                                    )}
                                                </ul>
                                                <ul className={style.contact}>
                                                    {ticket.contactToCallback.medium && ticket.contactToCallback.medium.contactMediumType == 'Mail' && (
                                                        <li>
                                                            <Icon icon='mail' size='xs' />
                                                            <span> {ticket.contactToCallback.medium && ticket.contactToCallback.medium.mail}</span>
                                                        </li>
                                                    )}
                                                </ul>
                                                <ul className={style.contact}>
                                                    {ticket.contactToCallback.medium && ticket.contactToCallback.medium.contactMediumType == 'Fax' && (
                                                        <li>
                                                            <Icon icon='fax' size='xs' />
                                                            <span> {phonez(ticket.contactToCallback.medium && ticket.contactToCallback.medium.fax).format()}</span>
                                                        </li>
                                                    )}
                                                </ul>
                                                {ticket.contactToCallback.comment && (
                                                    <div className={cx(style.comment, style.warning)}>
                                                        <p>{ticket.contactToCallback.comment}</p>
                                                    </div>
                                                )}
                                                <ul className={style.callingGroup}>
                                                    <li>
                                                        {ticket._links.find(linkFinder('EmitCallTo')) && (
                                                            <Button
                                                                onClick={(e) => this._openEmitReceiveCallModal(e, 'EmitCallToModal', null, null, ticket.contactToCallback)}>
                                                                <p>{i18n.emitCallz}</p>
                                                                <Icon icon='emitCall' size='sm' />
                                                            </Button>
                                                        )}
                                                    </li>
                                                    <li>
                                                        {ticket._links.find(linkFinder('ReceiveCall')) && (
                                                            <Button
                                                                onClick={(e) => this._openEmitReceiveCallModal(e, 'ReceiveCallModal', null, null, ticket.contactToCallback)}>
                                                                <p>{i18n.receiveCallz}</p>
                                                                <Icon icon='receiveCall' size='sm' />
                                                            </Button>
                                                        )}
                                                    </li>
                                                </ul>
                                            </Card>
                                        </Col>
                                    )}
                                    <Col sm={ticket.contactToCallback && 12 || 6}>
                                        <TicketAddressCard
                                            kind='tab'
                                            split={!!ticket.contactToCallback}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    {ticket.assignee && (
                                        <Col sm={ticket.report && 6 || 12}>
                                            <TicketAssigneeCard
                                                kind='tab'
                                                split={!ticket.report}
                                                onSubmit={(e, r, p) => this._openEmitReceiveCallModal(e, r, p, null, null)} />
                                        </Col>
                                    )}
                                    {ticket.report && (
                                        <Col sm={6}>
                                            <Card
                                                position='right'
                                                header={cardHeader(i18n.interventionReport)}>
                                                <Markdown markdown={ticket.report} />
                                            </Card>
                                        </Col>
                                    )}
                                </Row>
                                <div className={style.switch}>
                                    <ButtonToggle
                                        value={wizard.minorActiveStep}
                                        onChange={(s) => s && wizard.setActiveStep(s)}>
                                        <ButtonGroup justified>
                                            {ticket._links.find(linkFinder('IdentifyAssignee')) && (
                                                <Button
                                                    href='/'
                                                    value={0.1}>
                                                    {ticket.assignee && i18n.changeRecourse || i18n.identifyAssignee}
                                                </Button>
                                            )}
                                            {ticket._links.find(linkFinder(['AcceptIntervention', 'RefuseIntervention'])) && (
                                                <Button
                                                    href='/'
                                                    value={0.2}>
                                                    {i18n.interventionAcceptation}
                                                </Button>
                                            )}
                                            {ticket._links.find(linkFinder(CLOSE_TICKET_CMD_TYPES)) && (
                                                <Button
                                                    href='/'
                                                    value={0.3}>
                                                    {i18n.closeTicket}
                                                </Button>
                                            )}
                                        </ButtonGroup>
                                    </ButtonToggle>
                                </div>
                            </div>
                        )}
                        {wizard.matchActiveStep(1) && (
                            <OpenTicketLayout
                                step={wizard.minorActiveStep}
                                onSubmit={(s) => wizard.setActiveStep(s)} />
                        )}
                        {wizard.matchActiveStep(0.1) && ticket._links.find(linkFinder('IdentifyAssignee')) && (
                            <IdentifyAssigneeCard />
                        )}
                        {wizard.matchActiveStep(0.2) && ticket._links.find(linkFinder(['AcceptIntervention', 'RefuseIntervention'])) && (
                            <AcceptRefuseInterventionCard assignee={ticket.assignee}/>
                        )}
                        {wizard.matchActiveStep(0.3) && ticket._links.find(linkFinder(CLOSE_TICKET_CMD_TYPES)) && (
                            <CloseTicketCard />
                        )}
                        {wizard.matchActiveStep([2, 3, 4, 5, 6]) && (
                            <div>
                                {!matchMedia('sm') && (
                                    <NextStepCard
                                        ticket={ticket} />
                                )}
                                {!matchMedia('sm') && editMenuCard}
                                {ticket._links.find(linkFinder('AddMessage')) && (
                                    <div>
                                        {!matchMedia('sm') && (
                                            <AddMessageCard />
                                        )}
                                    </div>
                                )}
                                {!matchMedia('sm') && additionalDataCard}
                                {!matchMedia('sm') && (
                                    <NewTicketClaimCard
                                        ticket={ticket} />
                                )}
                                <PageHeader>{i18n.journalEvent}</PageHeader>
                                <PanelGroup>
                                    {journalAggregations.map((aggrega, index) => (
                                        <Panel collapsible
                                            key={index}
                                            className='panel-pageheader'
                                            defaultExpanded={index == 0}
                                            header={journalPanelHeader(aggrega)}>
                                            <ul className={style.journalBody}>
                                            {aggrega.events.map((event, index) => (
                                                <li
                                                    key={index}>
                                                    <div className={style.time}>
                                                        <Icon icon='clock' size='xs' />
                                                        <span>{moment(event.date).format(i18n.timeFormat.default)}</span>
                                                    </div>
                                                    <div className={style.container}>
                                                        <div>
                                                            {event.eventName == 'MessageAdded' && (
                                                                <Icon icon='quote' size='xs' />
                                                            )}
                                                            {CORRECT_TICKET_EVENT_NAMES.indexOf(event.eventName) >= 0 && ticket._links.find(linkFinder('CorrectTicketEventInformations')) && (
                                                                <a
                                                                    className={style.action}
                                                                    href=''
                                                                    onClick={(e) => this._openEventModal(e, 'CorrectTicketEventInformationsModal', event)}>
                                                                    <Icon icon='pencil' size='xs' />
                                                                </a>
                                                            )}
                                                            <span>
                                                                <span> <Markdown markdown={Ticket.replaceJournalEvent(Ticket.extractJournalEvent(i18n.journalEventEnum, event), event)}/></span>
                                                                {event.updated.length > 0 && (
                                                                    <span className={style.info}> ({i18n.corrected})</span>
                                                                )}
                                                            </span>
                                                        </div>
                                                        {[event.data.callPurpose, event.data.comment].filter((t) => t).map((text, index) => (
                                                            <p key={index}>
                                                                <Icon icon='quote' size='xs' />
                                                                <span> {text}</span>
                                                            </p>
                                                        ))}
                                                    </div>
                                                </li>
                                            ))}
                                            </ul>
                                        </Panel>
                                    ))}
                                </PanelGroup>
                            </div>
                        )}
                    </Col>
                    <Col sm={4}>
                        {wizard.matchActiveStep(1) && (
                            <div>
                                {matchMedia('sm') && (
                                    <OpenTicketCompanyCard />
                                )}
                                <OpenTicketStreamCardLayout
                                    onSubmit={(e, a, c, t) => this._openEmitReceiveCallModal(e, 'ReceiveCallModal', null, c, null, t)} />
                            </div>
                        )}
                        {wizard.matchActiveStep([2, 3, 4, 5, 6]) && (
                            <div>
                                {matchMedia('sm')
                                    && [
                                        (
                                            <div className={style.exportAndSatisfaction}>
                                                {exportButton}
                                                <div className={style.satisfaction}>
                                                    <SatisfactionButton block
                                                        ticket={ticket}
                                                        onClick={(e) => this._openModal(e, 'AnswerModal')} />
                                                </div>
                                            </div>
                                        )
                                        , instructionsCard
                                        , metricBoxes
                                        , <NextStepCard ticket={ticket} />
                                        , finishMissionEventCard
                                        , companyCard
                                        , <ShowDocumentsCard simplifiedRequest={ticket.linkedEntities.openedFromSimplifiedRequest}
                                                             ticket={ticket.uid} />
                                        , editMenuCard
                                        , additionalDataCard
                                    ]}
                                {ticket._links.find(linkFinder('AddMessage')) && (
                                    <div>
                                        {matchMedia('sm') && (
                                            <AddMessageCard />
                                        )}
                                    </div>
                                )}
                                {matchMedia('sm') && (
                                    <NewTicketClaimCard
                                        ticket={ticket} />
                                )}
                            </div>
                        )}
                    </Col>
                </Row>
                {wizard.matchActiveStep(1) && (
                    <OpenTicketCompanyModal
                        onSubmit={() => this._navigate('/tickets')} />
                )}
                {ticket._links.find(linkFinder('ReportSendingServiceOrder')) && (
                    <ReportSendingServiceOrderModal
                        show={openedModal == 'ReportSendingServiceOrderModal'}
                        onHide={() => this._closeModal()} />
                )}
                {ticket._links.find(linkFinder('DefineInterventionDeadline')) && (
                    <DefineInterventionDeadlineModal
                        show={openedModal == 'DefineInterventionDeadlineModal'}
                        onHide={() => this._closeModal()} />
                )}
                {ticket._links.find(linkFinder('ReportFormalNoticeForProvider')) && (
                    <ReportFormalNoticeForProviderModal
                        show={openedModal == 'ReportFormalNoticeForProviderModal'}
                        onHide={() => this._closeModal()} />
                )}
                {ticket._links.find(linkFinder('ScheduleIntervention')) && (
                    <ScheduleInterventionModal
                        show={openedModal == 'ScheduleInterventionModal'}
                        onHide={() => this._closeModal()} />
                )}
                {ticket._links.find(linkFinder('CorrectTicketInformations')) && (
                    <CorrectTicketInformationsModal
                        show={openedModal == 'CorrectTicketInformationsModal'}
                        onHide={() => this._closeModal()} />
                )}
                {activeEvent && ticket._links.find(linkFinder('CorrectTicketEventInformations')) && (
                    <CorrectTicketEventInformationsModal
                        event={activeEvent}
                        show={openedModal == 'CorrectTicketEventInformationsModal'}
                        onHide={() => this._closeModal()} />
                )}
                {(wizard.matchActiveStep(1) || ticket._links.find(linkFinder('ReceiveCall'))) && (
                    <ReceiveCallModal
                        assignee={activeAssignee}
                        caller={activeCaller}
                        contactToCallback={activeContactToCallback}
                        ticket={activeTicket || ticket}
                        show={openedModal == 'ReceiveCallModal'}
                        onHide={() => this._closeModal()} />
                )}
                {ticket._links.find(linkFinder('EmitCallTo')) && (
                    <EmitCallToModal
                        assignee={activeAssignee}
                        caller={activeCaller}
                        contactToCallback={activeContactToCallback}
                        show={openedModal == 'EmitCallToModal'}
                        onHide={() => this._closeModal()} />
                )}
                {ticket._links.find(linkFinder('FinishMission')) && (
                    <FinishMissionModal
                        show={openedModal == 'FinishMissionModal'}
                        onHide={() => this._closeModal()} />
                )}
                <ExportTicketsModal
                    ticket={ticket}
                    show={openedModal == 'ExportTicketsModal'}
                    onHide={() => this._closeModal()} />
                <AnswerModal
                    ticket={ticket}
                    show={openedModal == 'AnswerModal'}
                    onHide={() => this._closeModal()} />
            </div>
        )
    }
}

TicketDetail = connectWizard({
    activeStep: selectActiveStep
})(TicketDetail)

TicketDetail = connect((state) => ({
    progress: state.progress,
    ticket: state.ticket.ticket,
    _appLinks: state.app._links
}))(TicketDetail)

export default TicketDetail


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketDetail.js